module.exports = __webpack_public_path__ + "static/media/image3.45bd6e47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/image3.svg
// module id = 3053
// module chunks = 7